import { Typography } from "@mui/material";
import {Container} from "@mui/material";
import { CssBaseline } from "@mui/material";
export default function PricingPage(){
    return(
        <Container component='main'>
            <CssBaseline />
            <Typography>
                Pricing Page
            </Typography>
        </Container>
    );
}